import 'svelte/internal/disclose-version';

Flashcard[$.FILENAME] = 'src/ui/Flashcard.svelte';

import * as $ from 'svelte/internal/client';
import { tick } from "svelte";

import {
	flashcardView,
	formatInput,
	needsTones,
	pickTone,
	saveLocks,
	toneAnswer,
	toneChoices,
	toneEdit,
	tonePreview,
	toneStep
} from "./flashcard.ts";

import { Press } from "./keys.ts";
import { hush, speak, watchVoices } from "./speech.ts";

var root = $.add_locations($.from_html(`<span class="blank svelte-1jsu2jlx68a1y"></span>`), Flashcard[$.FILENAME], [[251, 34]]);
var root_1 = $.add_locations($.from_html(`<span class="lit svelte-1jsu2jlx68a1y"> </span>`), Flashcard[$.FILENAME], [[251, 68]]);

var root_2 = $.add_locations(
	$.from_html(
		`
                  <!>
                `,
		1
	),
	Flashcard[$.FILENAME],
	[]
);

var root_3 = $.add_locations(
	$.from_html(
		`
              <span class="shape svelte-1jsu2jlx68a1y" role="img">
                <!>
              </span>
            `,
		1
	),
	Flashcard[$.FILENAME],
	[[249, 14]]
);

var root_4 = $.add_locations($.from_html(`<span class="pos svelte-1jsu2jlx68a1y"> </span>`), Flashcard[$.FILENAME], [[255, 26]]);

var root_5 = $.add_locations(
	$.from_html(
		`
          <p class="cue svelte-1jsu2jlx68a1y">
            <!>
            <!>
          </p>
        `,
		1
	),
	Flashcard[$.FILENAME],
	[[247, 10]]
);

var root_6 = $.add_locations(
	$.from_html(
		`
      <div class="gloss svelte-1jsu2jlx68a1y">
        <p class="english svelte-1jsu2jlx68a1y" lang="en"> </p>
        <!>
      </div>
    `,
		1
	),
	Flashcard[$.FILENAME],
	[[244, 6, [[245, 8]]]]
);

var root_7 = $.add_locations($.from_html(`<p class="reading svelte-1jsu2jlx68a1y" lang="zh-Latn"> </p>`), Flashcard[$.FILENAME], [[262, 26]]);

var root_8 = $.add_locations(
	$.from_html(
		`
      <div class="han svelte-1jsu2jlx68a1y">
        <p class="prompt svelte-1jsu2jlx68a1y" lang="zh-Hans"> </p>
        <!>
      </div>
    `,
		1
	),
	Flashcard[$.FILENAME],
	[[260, 6, [[261, 8]]]]
);

var root_9 = $.add_locations(
	$.from_html(
		`
          <span class="script svelte-1jsu2jlx68a1y" aria-hidden="true" lang="zh-Hans">拼音</span>
        `,
		1
	),
	Flashcard[$.FILENAME],
	[[269, 10]]
);

var root_10 = $.add_locations(
	$.from_html(
		`
          <span class="script svelte-1jsu2jlx68a1y" aria-hidden="true">EN</span>
        `,
		1
	),
	Flashcard[$.FILENAME],
	[[271, 10]]
);

var root_11 = $.add_locations(
	$.from_html(
		`
                  <button type="button" lang="zh-Latn" class="svelte-1jsu2jlx68a1y"> </button>
                `,
		1
	),
	Flashcard[$.FILENAME],
	[[298, 18]]
);

var root_12 = $.add_locations(
	$.from_html(
		`
              <li role="group">
                <!>
              </li>
            `,
		1
	),
	Flashcard[$.FILENAME],
	[[296, 14]]
);

var root_13 = $.add_locations(
	$.from_html(
		`
        <div class="tones svelte-1jsu2jlx68a1y" tabindex="-1" role="group" aria-label="Tones">
          <ol class="syllables svelte-1jsu2jlx68a1y">
            <!>
          </ol>
          <div class="pair svelte-1jsu2jlx68a1y">
            <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions -->
            <label class="btn svelte-1jsu2jlx68a1y">Back</label>
            <button type="button" class="svelte-1jsu2jlx68a1y">Check</button>
          </div>
        </div>
      `,
		1
	),
	Flashcard[$.FILENAME],
	[[293, 8, [[294, 10], [305, 10, [[307, 12], [308, 12]]]]]]
);

var root_14 = $.add_locations(
	$.from_html(
		`
            <p class="verdict svelte-1jsu2jlx68a1y">Correct</p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[316, 12]]
);

var root_15 = $.add_locations(
	$.from_html(
		`
            <p class="unseen svelte-1jsu2jlx68a1y">Not quite</p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[318, 12]]
);

var root_16 = $.add_locations($.from_html(`<span class="word svelte-1jsu2jlx68a1y" lang="zh-Hans"> </span>`), Flashcard[$.FILENAME], [[321, 66]]);
var root_17 = $.add_locations($.from_html(`<kbd class="svelte-1jsu2jlx68a1y">P</kbd>`), Flashcard[$.FILENAME], [[339, 25]]);

var root_18 = $.add_locations(
	$.from_html(
		`
              <!-- TODO: Keep P usable after coarse-result blur; form-scoped keys miss it until the input is refocused. -->
              <button type="button" tabindex="-1" aria-label="Play pronunciation">
                <svg viewBox="0 0 24 24" aria-hidden="true" class="svelte-1jsu2jlx68a1y">
                  <path d="M3 9h4l5-4v14l-5-4H3z" fill="currentColor" class="svelte-1jsu2jlx68a1y"></path>
                  <path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a8.5 8.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="svelte-1jsu2jlx68a1y"></path>
                </svg>
              </button>
              <!>
            `,
		1
	),
	Flashcard[$.FILENAME],
	[[324, 14, [[334, 16, [[335, 18], [336, 18]]]]]]
);

var root_19 = $.add_locations(
	$.from_html(
		`
            <p class="also svelte-1jsu2jlx68a1y"> </p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[343, 12]]
);

var root_20 = $.add_locations($.from_html(`<kbd class="svelte-1jsu2jlx68a1y">A</kbd>`), Flashcard[$.FILENAME], [[348, 52]]);

var root_21 = $.add_locations(
	$.from_html(
		`
              <button type="button">
                Add alternate translation<!>
              </button>
            `,
		1
	),
	Flashcard[$.FILENAME],
	[[347, 14]]
);

var root_22 = $.add_locations($.from_html(`<kbd class="svelte-1jsu2jlx68a1y">Enter</kbd>`), Flashcard[$.FILENAME], [[354, 34]]);

var root_23 = $.add_locations(
	$.from_html(
		`
                <button type="button">
                  Retry<!>
                </button>
              `,
		1
	),
	Flashcard[$.FILENAME],
	[[353, 16]]
);

var root_24 = $.add_locations($.from_html(`<kbd class="svelte-1jsu2jlx68a1y">Enter</kbd>`), Flashcard[$.FILENAME], [[367, 62]]);

var root_25 = $.add_locations(
	$.from_html(
		`
            <p class="save saving svelte-1jsu2jlx68a1y">Saving</p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[372, 12]]
);

var root_26 = $.add_locations(
	$.from_html(
		`
            <div class="save failed svelte-1jsu2jlx68a1y" role="alert">
              <p class="svelte-1jsu2jlx68a1y"><strong class="svelte-1jsu2jlx68a1y">Answer not saved.</strong> </p>
              <p class="hint svelte-1jsu2jlx68a1y"> </p>
            </div>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[374, 12, [[375, 14, [[375, 17]]], [376, 14]]]]
);

var root_27 = $.add_locations(
	$.from_html(
		`
            <p class="save svelte-1jsu2jlx68a1y" role="status"> </p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[379, 12]]
);

var root_28 = $.add_locations(
	$.from_html(
		`
            <p class="save svelte-1jsu2jlx68a1y" role="status">The server graded this answer differently.</p>
          `,
		1
	),
	Flashcard[$.FILENAME],
	[[381, 12]]
);

var root_29 = $.add_locations(
	$.from_html(
		`
        <div class="reveal svelte-1jsu2jlx68a1y" role="status">
          <!>
          <p class="answer svelte-1jsu2jlx68a1y"> <!>
            <!>
          </p>
          <!>
          <div class="actions svelte-1jsu2jlx68a1y">
            <!>
            <div class="pair svelte-1jsu2jlx68a1y">
              <!>
              <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions -->
              <label>
                Next card<!>
              </label>
            </div>
          </div>
          <!>
        </div>
      `,
		1
	),
	Flashcard[$.FILENAME],
	[[314, 8, [[320, 10], [345, 10, [[351, 12, [[358, 14]]]]]]]]
);

var root_30 = $.add_locations(
	$.from_html(
		`

<div class="flashcard svelte-1jsu2jlx68a1y">
  <article class="card svelte-1jsu2jlx68a1y">
    <header class="svelte-1jsu2jlx68a1y">
      <span class="svelte-1jsu2jlx68a1y"> </span>
      <span class="svelte-1jsu2jlx68a1y"> </span>
    </header>

    <!>

    <form class="svelte-1jsu2jlx68a1y">
      <label class="field svelte-1jsu2jlx68a1y">
        <!>
        <input autocomplete="off" autocapitalize="none" spellcheck="false" class="svelte-1jsu2jlx68a1y"/>
      </label>

      <!>

      <!>
    </form>
  </article>
</div>

`,
		1
	),
	Flashcard[$.FILENAME],
	[
		[
			236,
			0,
			[
				[
					237,
					2,
					[
						[238, 4, [[239, 6], [240, 6]]],
						[266, 4, [[267, 6, [[273, 8]]]]]
					]
				]
			]
		]
	]
);

export default function Flashcard($$anchor, $$props) {
	const // Ask letters, then tones on buttons; defaults to a coarse primary pointer.
	answerId = $.props_id();

	$.check_target(new.target);
	$.push($$props, true, Flashcard);

	let result = $.prop($$props, 'result', 3, null),
		save = $.prop($$props, 'save', 3, null),
		busy = $.prop($$props, 'busy', 3, false),
		hints = $.prop($$props, 'hints', 3, false);

	let given = $.tag($.state(""), 'given');
	let input = $.tag($.state(void 0), 'input');
	let armed = $.tag($.state(null), 'armed');
	let tones = $.tag($.state(null), 'tones');
	let panel = $.tag($.state(void 0), 'panel');
	let coarse = $.tag($.state(false), 'coarse');
	let voices = $.tag($.state(false), 'voices');
	let plays = 0;
	const press = new Press();
	const locked = $.tag($.derived(() => saveLocks(save()) || busy()), 'locked');
	const canAdd = $.tag($.derived(() => $.strict_equals($$props.card.kind, "meaning") && $.strict_equals(result(), null, false) && !result().correct), 'canAdd');

	$.user_effect(() => {
		$$props.card;
		$.set(given, "");
		$.set(tones, null);
		$.get(input)?.focus();
	});

	$.user_effect(() => {
		$$props.card;
		plays = 0;

		return hush;
	});

	$.user_effect(() => watchVoices((v) => $.set(voices, v, true)));

	// On touch the result leaves the input unfocused, so Next card's label gives it a fresh, keyboard-opening focus.
	$.user_effect(() => {
		if (result()) {
			$.set(tones, null);

			if ($$props.touch ?? $.get(coarse)) $.get(input)?.blur(); else $.get(input)?.focus();
		}
	});

	$.user_effect(() => {
		const query = matchMedia("(pointer: coarse)");

		$.set(coarse, query.matches, true);

		const change = () => $.set(coarse, query.matches, true);

		query.addEventListener("change", change);

		return () => query.removeEventListener("change", change);
	});

	$.user_effect(() => {
		$$props.card;
		result();
		save()?.tag;
		disarm();
	});

	function disarm() {
		press.cancel();
		$.set(armed, null);
	}

	const view = $.tag($.derived(() => flashcardView($$props.card)), 'view');

	// TODO: Retain explicit neutral-tone intent; formatInput turns ma5 into ma and asks for its tone again on touch.
	const toTones = $.tag($.derived(() => $.get(view).wantsPinyin && ($$props.touch ?? $.get(coarse)) && !result() && !$.get(tones) && needsTones($.get(given))), 'toTones');

	const assembled = $.tag($.derived(() => $.get(tones) && toneAnswer($.get(tones))), 'assembled');

	// TODO: Restore sayGiven's Play your answer/Y action; the unlock revert also removed that unrelated feature.
	const sayable = $.tag($.derived(() => $.strict_equals(result(), null, false) && $.strict_equals($.get(view).speak, null, false) && $.get(voices)), 'sayable');

	// The tone step is buttons only: the input goes read-only and the keyboard away.
	async function askTones(step) {
		$.set(tones, step, true);
		$.get(input)?.blur();
		(await $.track_reactivity_loss(tick()))();
		$.get(panel)?.focus();
	}

	function pick(at, tone) {
		if ($.get(tones)) $.set(tones, pickTone($.get(tones), at, tone), true);
	}

	function check() {
		if ($.get(assembled)) $$props.onsubmit?.($.get(assembled));
	}

	// On the tested iOS build, fresh native label focus opens the keyboard when script focus cannot.
	// Keep the input editable, labels unfocusable and mousedown uncancelled; defer actions so native focus wins.
	// Enter reaches Next through the form. See wiki/show-keyboard-at-right-time.md.
	function editable() {
		if (!$.get(input)) return;

		$.get(input).readOnly = false;
		$.get(input).removeAttribute("inputmode");
	}

	$.user_effect(() => {
		const at = $.get(tones)?.current;

		if ($.equals(at, null, false)) $.get(panel)?.querySelectorAll(".strip")[at]?.scrollIntoView({ block: "nearest" });
	});

	// Use keydown: Firefox rejects execCommand in beforeinput; native edits preserve tone undo.
	function ontonekey(e) {
		const el = $.get(input);

		if (!el || $.strict_equals(e.target, el, false) || !$.get(view).wantsPinyin || e.isComposing || e.metaKey || e.ctrlKey || e.altKey || result() || $.get(tones)) return false;

		const edit = toneEdit(el.value, el.selectionStart ?? 0, el.selectionEnd ?? 0, e.key);

		if (!edit) return false;

		e.preventDefault();
		el.setSelectionRange(edit.start, edit.end);

		if (!document.execCommand("insertText", false, edit.text)) {
			// TODO: Preserve tone undo on failure; setRangeText bypasses native edit history.
			el.setRangeText(edit.text, edit.start, edit.end, "end");
		}

		$.set(given, el.value, true);

		return true;
	}

	function oninput(e) {
		// TODO: Convert paste/IME as edits after composition; whole-value rewrites lose caret and undo.
		const el = e.currentTarget;

		if (e.inputType?.startsWith("history")) {
			// Chrome undo reselects the restored letters; collapse to their end.
			el.setSelectionRange(el.selectionEnd, el.selectionEnd);

			$.set(given, el.value, true);
		} else $.set(given, formatInput($$props.card.kind, el.value), true);
	}

	function fire(action) {
		if ($.strict_equals(action, "retry")) {
			if ($.strict_equals(save()?.tag, "failed")) $$props.onretry?.();
		} else if ($.strict_equals(action, "add")) {
			if ($.get(canAdd) && result()) $$props.onaddalternate?.(result().given);
		} else if ($.strict_equals(action, "say")) {
			if ($.get(view).speak) speak($.get(view).speak, $.strict_equals(plays++ % 2, 1));
		} else if (!$.get(locked)) $$props.oncontinue?.();
	}

	function submit(e) {
		e.preventDefault();

		if (result()) {
			fire("next");
		} else if ($.get(tones)) {
			check();
		} else {
			const answer = $.get(given).trim();

			if (!answer) return;

			const step = $.get(toTones) ? toneStep(answer) : null;

			if (step) askTones(step); else $$props.onsubmit?.(answer);
		}
	}

	// Option changes e.key on macOS; recognize Alt-P by its physical key.
	function playKey(e) {
		return !e.isComposing && !e.metaKey && !e.ctrlKey && (e.altKey
			? $.strict_equals(e.code, "KeyP")
			: $.strict_equals(e.key, "p"));
	}

	// Result keys: Enter continues or retries; r retries; a adds an alternate; p or Alt-P plays pronunciation.
	// TODO: Honor focused result buttons on Enter instead of advancing; accept native/assistive detail=0 Add/Retry clicks.
	function actionFor(e) {
		if ($.strict_equals(e.key, "Enter")) return $.strict_equals(save()?.tag, "failed") ? "retry" : $.get(locked) ? null : "next";
		if ($.get(sayable) && playKey(e)) return "say";
		if (e.metaKey || e.ctrlKey || e.altKey) return null;
		if ($.strict_equals(e.key, "r")) return $.strict_equals(save()?.tag, "failed") ? "retry" : null;
		if ($.strict_equals(e.key, "a") && $.get(canAdd)) return "add";

		return null;
	}

	function onkeydown(e) {
		if (ontonekey(e)) return;

		// TODO: Keep composing Enter from submitting or advancing an answer.
		if (!result()) {
			if ($.strict_equals(e.key, "Enter") && e.repeat) e.preventDefault();

			return;
		}

		const plain = !(e.metaKey || e.ctrlKey || e.altKey);

		if ($.strict_equals(e.key, "Enter", false) && !(plain && ($.strict_equals(e.key, "r") || $.strict_equals(e.key, "a") && $.get(canAdd))) && !($.get(sayable) && playKey(e))) return;

		e.preventDefault();

		const action = actionFor(e);

		if (action && press.down(e.code || e.key, e.repeat, action)) $.set(armed, action, true);
	}

	function onkeyup(e) {
		const action = press.up(e.code || e.key);

		if (!action) return;

		$.set(armed, null);
		fire(action);
	}

	function enterKey(form) {
		form.addEventListener("keydown", onkeydown);
		form.addEventListener("keyup", onkeyup);
		window.addEventListener("blur", disarm);

		return () => {
			form.removeEventListener("keydown", onkeydown);
			form.removeEventListener("keyup", onkeyup);
			window.removeEventListener("blur", disarm);
		};
	}

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_30();
	var div = $.sibling($.first_child(fragment));
	let styles;
	var article = $.sibling($.child(div));
	var header = $.sibling($.child(article));
	var span = $.sibling($.child(header));
	var text = $.only_child(span);
	var span_1 = $.sibling(span, 2);
	var text_1 = $.only_child(span_1, true);

	$.next();
	$.reset(header);

	var node = $.sibling(header, 2);

	{
		var consequent_4 = ($$anchor) => {
			var fragment_1 = root_6();
			var div_1 = $.sibling($.first_child(fragment_1));
			let styles_1;
			var p = $.sibling($.child(div_1));
			var text_2 = $.only_child(p, true);
			var node_1 = $.sibling(p, 2);

			{
				var consequent_3 = ($$anchor) => {
					var fragment_2 = root_5();
					var p_1 = $.sibling($.first_child(fragment_2));
					var node_2 = $.sibling($.child(p_1));

					{
						var consequent_1 = ($$anchor) => {
							var fragment_3 = root_3();
							var span_2 = $.sibling($.first_child(fragment_3));
							let styles_2;
							var node_3 = $.sibling($.child(span_2));

							$.add_svelte_meta(
								() => $.each(node_3, 17, () => $.get(view).shape, $.index, ($$anchor, c) => {
									$.next();

									var fragment_4 = root_2();
									var node_4 = $.sibling($.first_child(fragment_4));

									{
										var consequent = ($$anchor) => {
											var span_3 = root();

											$.append($$anchor, span_3);
										};

										var alternate = ($$anchor) => {
											var span_4 = root_1();
											var text_3 = $.only_child(span_4, true);

											$.template_effect(() => $.set_text(text_3, $.get(c)));
											$.append($$anchor, span_4);
										};

										$.add_svelte_meta(
											() => $.if(node_4, ($$render) => {
												if ($.strict_equals($.get(c), null)) $$render(consequent); else $$render(alternate, -1);
											}),
											'if',
											Flashcard,
											251,
											18
										);
									}

									$.next();
									$.append($$anchor, fragment_4);
								}),
								'each',
								Flashcard,
								250,
								16
							);

							$.next();
							$.reset(span_2);
							$.next();

							$.template_effect(() => {
								$.set_attribute(span_2, 'aria-label', $.get(view).shapeLabel);
								styles_2 = $.set_style(span_2, '', styles_2, { '--slots': $.get(view).shape.length });
							});

							$.append($$anchor, fragment_3);
						};

						$.add_svelte_meta(
							() => $.if(node_2, ($$render) => {
								if ($.get(view).shape.length) $$render(consequent_1);
							}),
							'if',
							Flashcard,
							248,
							12
						);
					}

					var node_5 = $.sibling(node_2, 2);

					{
						var consequent_2 = ($$anchor) => {
							var span_5 = root_4();
							var text_4 = $.only_child(span_5, true);

							$.template_effect(() => $.set_text(text_4, $$props.card.pos));
							$.append($$anchor, span_5);
						};

						$.add_svelte_meta(
							() => $.if(node_5, ($$render) => {
								if ($$props.card.pos) $$render(consequent_2);
							}),
							'if',
							Flashcard,
							255,
							12
						);
					}

					$.next();
					$.reset(p_1);
					$.next();
					$.append($$anchor, fragment_2);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.get(view).shape.length || $$props.card.pos) $$render(consequent_3);
					}),
					'if',
					Flashcard,
					246,
					8
				);
			}

			$.next();
			$.reset(div_1);
			$.next();

			$.template_effect(
				($0) => {
					styles_1 = $.set_style(div_1, '', styles_1, { '--len': $0 });
					$.set_text(text_2, $$props.card.prompt);
				},
				[() => [...$$props.card.prompt].length]
			);

			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_5 = root_8();
			var div_2 = $.sibling($.first_child(fragment_5));
			var p_2 = $.sibling($.child(div_2));
			var text_5 = $.only_child(p_2, true);
			var node_6 = $.sibling(p_2, 2);

			{
				var consequent_5 = ($$anchor) => {
					var p_3 = root_7();
					var text_6 = $.only_child(p_3, true);

					$.template_effect(() => $.set_text(text_6, $.get(view).reading));
					$.append($$anchor, p_3);
				};

				$.add_svelte_meta(
					() => $.if(node_6, ($$render) => {
						if ($.get(view).reading) $$render(consequent_5);
					}),
					'if',
					Flashcard,
					262,
					8
				);
			}

			$.next();
			$.reset(div_2);
			$.next();
			$.template_effect(() => $.set_text(text_5, $$props.card.prompt));
			$.append($$anchor, fragment_5);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.strict_equals($$props.card.kind, "recall")) $$render(consequent_4); else $$render(alternate_1, -1);
			}),
			'if',
			Flashcard,
			243,
			4
		);
	}

	var form_1 = $.sibling(node, 2);
	var label = $.sibling($.child(form_1));
	var node_7 = $.sibling($.child(label));

	{
		var consequent_6 = ($$anchor) => {
			var fragment_6 = root_9();

			$.next(2);
			$.append($$anchor, fragment_6);
		};

		var alternate_2 = ($$anchor) => {
			var fragment_7 = root_10();

			$.next(2);
			$.append($$anchor, fragment_7);
		};

		$.add_svelte_meta(
			() => $.if(node_7, ($$render) => {
				if ($.get(view).wantsPinyin) $$render(consequent_6); else $$render(alternate_2, -1);
			}),
			'if',
			Flashcard,
			268,
			8
		);
	}

	var input_1 = $.sibling(node_7, 2);

	$.remove_input_defaults(input_1);
	$.bind_this(input_1, ($$value) => $.set(input, $$value), () => $.get(input));
	$.next();
	$.reset(label);

	var node_8 = $.sibling(label, 2);

	{
		var consequent_7 = ($$anchor) => {
			var fragment_8 = root_13();
			var div_3 = $.sibling($.first_child(fragment_8));
			var ol = $.sibling($.child(div_3));
			var node_9 = $.sibling($.child(ol));

			$.add_svelte_meta(
				() => $.each(node_9, 17, () => $.get(tones).slots, $.index, ($$anchor, slot, at) => {
					$.next();

					var fragment_9 = root_12();
					var li = $.sibling($.first_child(fragment_9));
					let classes;
					var node_10 = $.sibling($.child(li));

					$.add_svelte_meta(
						() => $.each(node_10, 17, () => toneChoices($.get(slot).letters), (choice) => choice.tone, ($$anchor, choice) => {
							$.next();

							var fragment_10 = root_11();
							var button = $.sibling($.first_child(fragment_10));
							var text_7 = $.only_child(button);

							$.next();

							$.template_effect(() => {
								$.set_attribute(button, 'aria-pressed', $.strict_equals($.get(slot).tone, $.get(choice).tone));

								$.set_text(text_7, `
                    ${$.get(choice).label ?? ''}
                  `);
							});

							$.delegated('click', button, function click() {
								return pick(at, $.get(choice).tone);
							});

							$.append($$anchor, fragment_10);
						}),
						'each',
						Flashcard,
						297,
						16
					);

					$.next();
					$.reset(li);
					$.next();

					$.template_effect(() => {
						classes = $.set_class(li, 1, 'strip svelte-1jsu2jlx68a1y', null, classes, { current: $.strict_equals($.get(tones).current, at) });
						$.set_attribute(li, 'aria-label', `Tone for ${$.get(slot).letters ?? ''}`);
					});

					$.append($$anchor, fragment_9);
				}),
				'each',
				Flashcard,
				295,
				12
			);

			$.next();
			$.reset(ol);

			var div_4 = $.sibling(ol, 2);
			var node_11 = $.sibling($.child(div_4));
			var label_1 = $.sibling(node_11, 2);
			var button_1 = $.sibling(label_1, 2);

			$.next();
			$.reset(div_4);
			$.next();
			$.reset(div_3);
			$.bind_this(div_3, ($$value) => $.set(panel, $$value), () => $.get(panel));
			$.next();

			$.template_effect(() => {
				$.set_attribute(label_1, 'for', answerId);
				$.set_attribute(button_1, 'aria-disabled', $.get(assembled) ? undefined : "true");
			});

			$.delegated('touchstart', label_1, editable, void 0, true);

			$.delegated('click', label_1, function click_1() {
				return setTimeout(() => $.set(tones, null));
			});

			$.delegated('click', button_1, check);
			$.append($$anchor, fragment_8);
		};

		$.add_svelte_meta(
			() => $.if(node_8, ($$render) => {
				if ($.get(tones) && !result()) $$render(consequent_7);
			}),
			'if',
			Flashcard,
			292,
			6
		);
	}

	var node_12 = $.sibling(node_8, 2);

	{
		var consequent_22 = ($$anchor) => {
			var fragment_11 = root_29();
			var div_5 = $.sibling($.first_child(fragment_11));
			var node_13 = $.sibling($.child(div_5));

			{
				var consequent_8 = ($$anchor) => {
					var fragment_12 = root_14();

					$.next(2);
					$.append($$anchor, fragment_12);
				};

				var alternate_3 = ($$anchor) => {
					var fragment_13 = root_15();

					$.next(2);
					$.append($$anchor, fragment_13);
				};

				$.add_svelte_meta(
					() => $.if(node_13, ($$render) => {
						if (result().correct) $$render(consequent_8); else $$render(alternate_3, -1);
					}),
					'if',
					Flashcard,
					315,
					10
				);
			}

			var p_4 = $.sibling(node_13, 2);
			var text_8 = $.child(p_4);
			var node_14 = $.sibling(text_8);

			{
				var consequent_9 = ($$anchor) => {
					var span_6 = root_16();
					var text_9 = $.only_child(span_6, true);

					$.template_effect(() => $.set_text(text_9, $$props.card.word));
					$.append($$anchor, span_6);
				};

				$.add_svelte_meta(
					() => $.if(node_14, ($$render) => {
						if ($.strict_equals($$props.card.kind, "recall") && $$props.card.word) $$render(consequent_9);
					}),
					'if',
					Flashcard,
					321,
					25
				);
			}

			var node_15 = $.sibling(node_14, 2);

			{
				var consequent_11 = ($$anchor) => {
					var fragment_14 = root_18();
					var node_16 = $.sibling($.first_child(fragment_14));
					var button_2 = $.sibling(node_16, 2);
					let classes_1;
					var node_17 = $.sibling(button_2, 2);

					{
						var consequent_10 = ($$anchor) => {
							var kbd = root_17();

							$.append($$anchor, kbd);
						};

						$.add_svelte_meta(
							() => $.if(node_17, ($$render) => {
								if (hints()) $$render(consequent_10);
							}),
							'if',
							Flashcard,
							339,
							14
						);
					}

					$.next();

					$.template_effect(() => classes_1 = $.set_class(button_2, 1, 'say svelte-1jsu2jlx68a1y', null, classes_1, {
						pressed: $.strict_equals($.get(armed), "say"),
						tap: $$props.touch ?? $.get(coarse)
					}));

					$.delegated('mousedown', button_2, function mousedown(e) {
						return e.preventDefault();
					});

					$.delegated('click', button_2, function click_2() {
						return fire("say");
					});

					$.append($$anchor, fragment_14);
				};

				$.add_svelte_meta(
					() => $.if(node_15, ($$render) => {
						if ($.get(sayable)) $$render(consequent_11);
					}),
					'if',
					Flashcard,
					322,
					12
				);
			}

			$.next();
			$.reset(p_4);

			var node_18 = $.sibling(p_4, 2);

			{
				var consequent_12 = ($$anchor) => {
					var fragment_15 = root_19();
					var p_5 = $.sibling($.first_child(fragment_15));
					var text_10 = $.only_child(p_5);

					$.next();

					$.template_effect(
						($0, $1) => {
							$.set_attribute(p_5, 'title', $0);
							$.set_text(text_10, `also ${$1 ?? ''}`);
						},
						[
							() => $.get(view).alternatives.join(", "),
							() => $.get(view).alternatives.join(", ")
						]
					);

					$.append($$anchor, fragment_15);
				};

				$.add_svelte_meta(
					() => $.if(node_18, ($$render) => {
						if ($.get(view).alternatives.length) $$render(consequent_12);
					}),
					'if',
					Flashcard,
					342,
					10
				);
			}

			var div_6 = $.sibling(node_18, 2);
			var node_19 = $.sibling($.child(div_6));

			{
				var consequent_14 = ($$anchor) => {
					var fragment_16 = root_21();
					var button_3 = $.sibling($.first_child(fragment_16));
					let classes_2;
					var node_20 = $.sibling($.child(button_3));

					{
						var consequent_13 = ($$anchor) => {
							var kbd_1 = root_20();

							$.append($$anchor, kbd_1);
						};

						$.add_svelte_meta(
							() => $.if(node_20, ($$render) => {
								if (hints()) $$render(consequent_13);
							}),
							'if',
							Flashcard,
							348,
							41
						);
					}

					$.next();
					$.reset(button_3);
					$.next();
					$.template_effect(() => classes_2 = $.set_class(button_3, 1, 'svelte-1jsu2jlx68a1y', null, classes_2, { pressed: $.strict_equals($.get(armed), "add") }));

					$.delegated('click', button_3, function click_3(e) {
						return $.strict_equals(e.detail, 0, false) && fire("add");
					});

					$.append($$anchor, fragment_16);
				};

				$.add_svelte_meta(
					() => $.if(node_19, ($$render) => {
						if ($.get(canAdd)) $$render(consequent_14);
					}),
					'if',
					Flashcard,
					346,
					12
				);
			}

			var div_7 = $.sibling(node_19, 2);
			var node_21 = $.sibling($.child(div_7));

			{
				var consequent_16 = ($$anchor) => {
					var fragment_17 = root_23();
					var button_4 = $.sibling($.first_child(fragment_17));
					let classes_3;
					var node_22 = $.sibling($.child(button_4));

					{
						var consequent_15 = ($$anchor) => {
							var kbd_2 = root_22();

							$.append($$anchor, kbd_2);
						};

						$.add_svelte_meta(
							() => $.if(node_22, ($$render) => {
								if (hints()) $$render(consequent_15);
							}),
							'if',
							Flashcard,
							354,
							23
						);
					}

					$.next();
					$.reset(button_4);
					$.next();
					$.template_effect(() => classes_3 = $.set_class(button_4, 1, 'retry svelte-1jsu2jlx68a1y', null, classes_3, { pressed: $.strict_equals($.get(armed), "retry") }));

					$.delegated('click', button_4, function click_4(e) {
						return $.strict_equals(e.detail, 0, false) && fire("retry");
					});

					$.append($$anchor, fragment_17);
				};

				$.add_svelte_meta(
					() => $.if(node_21, ($$render) => {
						if ($.strict_equals(save()?.tag, "failed")) $$render(consequent_16);
					}),
					'if',
					Flashcard,
					352,
					14
				);
			}

			var node_23 = $.sibling(node_21, 2);
			var label_2 = $.sibling(node_23, 2);
			let classes_4;
			var node_24 = $.sibling($.child(label_2));

			{
				var consequent_17 = ($$anchor) => {
					var kbd_3 = root_24();

					$.append($$anchor, kbd_3);
				};

				$.add_svelte_meta(
					() => $.if(node_24, ($$render) => {
						if (hints() && $.strict_equals(save()?.tag, "failed", false)) $$render(consequent_17);
					}),
					'if',
					Flashcard,
					367,
					25
				);
			}

			$.next();
			$.reset(label_2);
			$.next();
			$.reset(div_7);
			$.next();
			$.reset(div_6);

			var node_25 = $.sibling(div_6, 2);

			{
				var consequent_18 = ($$anchor) => {
					var fragment_18 = root_25();

					$.next(2);
					$.append($$anchor, fragment_18);
				};

				var consequent_19 = ($$anchor) => {
					var fragment_19 = root_26();
					var div_8 = $.sibling($.first_child(fragment_19));
					var p_6 = $.sibling($.child(div_8));
					var text_11 = $.sibling($.child(p_6));

					$.reset(p_6);

					var p_7 = $.sibling(p_6, 2);
					var text_12 = $.only_child(p_7, true);

					$.next();
					$.reset(div_8);
					$.next();

					$.template_effect(() => {
						$.set_text(text_11, ` ${save().detail ?? ''}`);
						$.set_text(text_12, save().hint);
					});

					$.append($$anchor, fragment_19);
				};

				var consequent_20 = ($$anchor) => {
					var fragment_20 = root_27();
					var p_8 = $.sibling($.first_child(fragment_20));
					var text_13 = $.only_child(p_8, true);

					$.next();
					$.template_effect(() => $.set_text(text_13, save().note));
					$.append($$anchor, fragment_20);
				};

				var consequent_21 = ($$anchor) => {
					var fragment_21 = root_28();

					$.next(2);
					$.append($$anchor, fragment_21);
				};

				$.add_svelte_meta(
					() => $.if(node_25, ($$render) => {
						if ($.strict_equals(save()?.tag, "saving")) $$render(consequent_18); else if ($.strict_equals(save()?.tag, "failed")) $$render(consequent_19, 1); else if ($.strict_equals(save()?.tag, "conflicted")) $$render(consequent_20, 2); else if ($.strict_equals(save()?.tag, "confirmed") && save().regraded) $$render(consequent_21, 3);
					}),
					'if',
					Flashcard,
					371,
					10
				);
			}

			$.next();
			$.reset(div_5);
			$.next();

			$.template_effect(() => {
				$.set_text(text_8, `
            ${$$props.card.answer ?? ''}`);

				$.set_attribute(label_2, 'for', answerId);
				classes_4 = $.set_class(label_2, 1, 'btn svelte-1jsu2jlx68a1y', null, classes_4, { pressed: $.strict_equals($.get(armed), "next") });
				$.set_attribute(label_2, 'aria-disabled', $.get(locked) ? "true" : undefined);
				$.set_attribute(label_2, 'aria-busy', busy() || $.strict_equals(save()?.tag, "saving") ? "true" : undefined);
			});

			$.delegated(
				'touchstart',
				label_2,
				function touchstart() {
					return $.get(locked) || editable();
				},
				void 0,
				true
			);

			$.delegated('click', label_2, function click_5(e) {
				return $.get(locked) ? e.preventDefault() : setTimeout(() => fire("next"));
			});

			$.append($$anchor, fragment_11);
		};

		$.add_svelte_meta(
			() => $.if(node_12, ($$render) => {
				if (result()) $$render(consequent_22);
			}),
			'if',
			Flashcard,
			313,
			6
		);
	}

	$.next();
	$.reset(form_1);
	$.attach(form_1, () => enterKey);
	$.next();
	$.reset(article);
	$.next();
	$.reset(div);
	$.next();

	$.template_effect(
		($0) => {
			styles = $.set_style(div, '', styles, { '--chars': $.get(view).chars });
			$.set_attribute(article, 'data-kind', $$props.card.kind);
			$.set_attribute(article, 'data-result', result() ? result().correct ? "correct" : "wrong" : "asking");
			$.set_text(text, `${$$props.card.set ?? ''}, level ${$$props.card.level ?? ''}`);
			$.set_text(text_1, $.get(view).label);
			$.set_attribute(input_1, 'id', answerId);
			$.set_value(input_1, $0);
			$.set_attribute(input_1, 'placeholder', $.get(view).placeholder);
			$.set_attribute(input_1, 'maxlength', $.get(view).maxLength);
			input_1.readOnly = $.strict_equals(result(), null, false) || $.strict_equals($.get(tones), null, false);
			$.set_attribute(input_1, 'inputmode', $.get(tones) ? "none" : undefined);
			$.set_attribute(input_1, 'enterkeyhint', $.get(toTones) ? "next" : undefined);
			$.set_attribute(input_1, 'autocorrect', $.get(view).wantsPinyin ? "off" : undefined);
			$.set_attribute(input_1, 'lang', $.get(view).wantsPinyin ? "zh-Latn" : "en");
			$.set_attribute(input_1, 'aria-label', $.get(view).wantsPinyin ? "Answer in pinyin" : "Answer in English");
		},
		[
			() => result()
				? formatInput($$props.card.kind, result().given)
				: $.get(tones) ? tonePreview($.get(tones)) : $.get(given)
		]
	);

	$.event('submit', form_1, submit);
	$.delegated('input', input_1, oninput);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['input', 'click', 'touchstart', 'mousedown']);
import "bun-svelte:Flashcard.svelte-20xmrfu3p373d-style.css";